import { memo } from 'preact/compat';
import { Attachment } from 'components/MerchantTrackingWidget/components/Attachment';
import { UploadData } from 'components/MerchantTrackingWidget/components/ReturnRequestModal/interfaces/ReturnRequest.interface';

interface UploadItemProps {
  attachment: UploadData;
  onRemove: (id: string) => void;
}

const UploadItem = ({ attachment, onRemove }: UploadItemProps): JSX.Element => {
  return (
    <Attachment
      fileName={attachment.file.name}
      progress={attachment.progress}
      isLoading={attachment.loading}
      error={attachment.error}
      onRemove={() => onRemove(attachment.id)}
    />
  );
};

const MemoUploadItem = memo(UploadItem);
export { MemoUploadItem as UploadItem };
